import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify, {
  theme: {
    primary: "#0da572",
    secondary: "#c74298",
    accent: "#007d98",
    error: "#FF5252",
    info: "#2196F3",
    success: "#166c4d",
    warning: "#FFC107"
  }
});
